import { Component, OnInit, OnChanges, EventEmitter, Output, Input, HostListener, ViewChild } from '@angular/core';
import { CfetBaseComponent, CfetService, CFETILMEndpointsConstant, UrlUtil, CfetPageNamesConstant } from '../../../cfet-core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { environment } from './../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { LocationStrategy, Location } from '@angular/common';
import { ChangeDetectorRef } from '@angular/core';
import { CustomerEligibilityUtfWorkplaceComponent } from '../customer-eligibility-utf-workplace/customer-eligibility-utf-workplace.component';
import { forkJoin, of, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-customer-eligibility-utf-form',
  templateUrl: './customer-eligibility-utf-form.component.html',
  styleUrls: ['./customer-eligibility-utf-form.component.scss'],
    standalone: false
})

export class CustomerEligibilityUtfFormComponent extends CfetBaseComponent implements OnInit, OnChanges {
  customerEligibility: UntypedFormGroup;
  selectCategory: UntypedFormControl;
  selectRole: UntypedFormControl;
  openBadCodeModal: string = 'close';
  orgProfileData: any = null;
  affiliationCode: UntypedFormControl;
  isAffiliationFromUrl: boolean = false;
  orgId: any;
  isAffiliationFlow: boolean = false;
  affiliationCodeValue: string = '';
  isSpaOrg: boolean = false;
  continueWithoutAffiliation: boolean = false;
  isAffiliationCodeValid: boolean = false;
  categoryList: any = [];
  roleList: any = [];
  categoryValue = { 'value': '', 'text': 'Select' };
  roleValue = { 'value': '', 'text': 'Select' };
  selectedCategory = '';
  showCategory = true;
  showRole = false;
  showConfirmRole = false;
  showCheckboxQA = false;
  selectedRole = '';
  roleSelected = '';
  showConfirmCheckbox = false;
  checkCategory = '';
  checkRole = '';
  responderCategoriesresponse = {};
  fullCategoryData: any[] = [];
  selectedJobFunctionDetails: any;
  jobfunctionentity: any;
  hideButtons = true;
  showWorkplace = false;
  showIneligibility = false;
  hideWorkplace = false;
  showWorkplaceSection: boolean;
  showtickicon: boolean;
  stateAndZip: any;
  selectedconfirmValue: any = [];
  selectedconfirmValueExt: any = [];
  manuallyEnteredValues: any;
  getorgProfileInfo: any;
  state: any;
  zipcode: any;
  showLoading = false;
  showSpinner = false;
  showEditIcons = false;
  isPSEAffliationcode = false;
  disableCategoryContinueButton = true;
  disableRoleContinueButton = true;
  selectedJobQuestions: any[];
  messageNote: string;
  showNote: boolean;
  indexYesCount = 0;
  indexNoCount = 0;
  indexCount = 0;
  returnUrl = '';
  url = '';
  cId = '';
  backButtonTriggered = false;
  openPopUpUtf = '';
  openPopup: boolean;
  hideContinueWithoutCode = false;
  action: any;
  showBadCodeModal = false;
  showEligibilityCompletion: boolean = false;
  @Output() eligibilitycompletionstatus = new EventEmitter<any>();
  @Output() editSelected = new EventEmitter<any>();
  @Input() signupComplete: boolean;
  @Input() editButtonClicked: boolean;
  @Output() isRoleSelected = new EventEmitter<any>();
  @Output() progressTrackerEvent = new EventEmitter<any>();
  @Output() showCancelModal = new EventEmitter<any>();
  @Output() verificationTypeChange =
    new EventEmitter<'self' | 'agency' | null>();
  @ViewChild(CustomerEligibilityUtfWorkplaceComponent) child: CustomerEligibilityUtfWorkplaceComponent;
  displayNote: boolean = false;
  showConfirmedUserRole: boolean = false;
  userType: string = '';
  isEVSP: boolean = false;
  affiliationFanTypes: string[] = [];
  affiliationResponderJobs: any[] = [];
  rapidSosOrgs: any[] = [];
  isRapidSosFlow: boolean = false;
  private isEntityListLoading = false;
  private isRapidSosLoading = false;
  // RapidSOS orgs carry the FAN keyed by types (no retCode), so resolve it up front.
  rapidSosResolvedFan: string = '';
  private static readonly RAPIDSOS_AFFILIATION_CODE = 'RAPIDSOS';

  private logCategoryFlowState(stage: string, extra: any = {}) {
    console.log(`[EligibilityUTF] ${stage}`, {
      selectedCategory: this.selectedCategory,
      selectedRole: this.selectedRole,
      categoryListLength: Array.isArray(this.categoryList) ? this.categoryList.length : -1,
      roleListLength: Array.isArray(this.roleList) ? this.roleList.length : -1,
      isAffiliationFlow: this.isAffiliationFlow,
      isAffiliationCodeValid: this.isAffiliationCodeValid,
      showLoading: this.showLoading,
      ...extra
    });
  }

  constructor(private cfetService: CfetService,
    private cd: ChangeDetectorRef,
    private http: HttpClient,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private urlUtil: UrlUtil,
    private locationStrategy: LocationStrategy,
    private location: Location) {
    super();
    history.pushState(null, null, window.location.href);
    // to check if back or forward button is pressed.
    this.locationStrategy.onPopState(() => {
      history.pushState(null, null, window.location.href);
    });
  }

  private setLoading(loading: boolean): void {
    this.showLoading = loading || this.isEntityListLoading || this.isRapidSosLoading;
    this.cd.detectChanges();
  }

  private updateDropdownDisabledStates(): void {
    const categoryIsDisabled = !this.isAffiliationCodeValid && !this.continueWithoutAffiliation;
    const roleIsDisabled = categoryIsDisabled
      || !this.categoryValue?.value
      || this.categoryValue.value === 'Select';

    if (categoryIsDisabled) {
      this.selectCategory.disable({ emitEvent: false });
    } else {
      this.selectCategory.enable({ emitEvent: false });
    }

    if (roleIsDisabled) {
      this.selectRole.disable({ emitEvent: false });
    } else {
      this.selectRole.enable({ emitEvent: false });
    }
  }

  ngOnInit() {
    if (sessionStorage.getItem('showIneligibility') === 'true') {

      this.showIneligibility = true;

      this.showWorkplace = false;
      this.showWorkplaceSection = false;
      this.showEligibilityCompletion = false;
      this.showCategory = false;
      this.showRole = false;
      this.showConfirmRole = false;
      this.showConfirmedUserRole = false;

      sessionStorage.removeItem('showIneligibility');
      return;
    }
    const forceWorkplace = sessionStorage.getItem('forceWorkplaceSection');
    const isForceWorkplaceRecovery = this.router.url.includes('/eligibility') && forceWorkplace === 'true';

    if (isForceWorkplaceRecovery) {
      this.showCategory = false;
      this.showRole = false;
      this.showConfirmRole = false;
      this.showIneligibility = false;
      this.showEligibilityCompletion = false;
      this.showWorkplace = true;
      this.showWorkplaceSection = true;
      this.showConfirmedUserRole = true;
      this.isAffiliationFlow = true;
      this.hideButtons = false;
      this.showEditIcons = false;
      const savedCategory = sessionStorage.getItem('selectedCategory');
      const savedRole = sessionStorage.getItem('selectedRole');
      this.selectedCategory = savedCategory ?? '';
      this.selectedRole = savedRole ?? '';
      const savedJobFunctionDetails = sessionStorage.getItem('selectedJobFunctionDetails');
      const savedRoleList = sessionStorage.getItem('roleList');
      this.selectedJobFunctionDetails = savedJobFunctionDetails ? JSON.parse(savedJobFunctionDetails) : [];
      this.roleList = savedRoleList ? JSON.parse(savedRoleList) : [];

      sessionStorage.removeItem('forceWorkplaceSection');
    }
    this.progressTrackerEvent.emit('roleDetails');
    const eligibilitySignup = sessionStorage.getItem('eligibilty-signup');
    if (eligibilitySignup && eligibilitySignup !== 'undefined') {
      this.showConfirmRole = true;
      this.showEditIcons = true;
      this.showWorkplace = true;
      this.showCategory = false;
      this.backButtonTriggered = true;
      this.action = true;
    }
    this.selectCategory = new UntypedFormControl({ value: '', disabled: true }, [Validators.required]);
    this.selectRole = new UntypedFormControl({ value: '', disabled: true }, [Validators.required]);
    this.cfetService.isLandingPage.next(false);
    this.affiliationCode = new UntypedFormControl('');
    this.hideContinueWithoutCode = sessionStorage.getItem('hideContinueWithoutCode') === 'true';
    if(sessionStorage.getItem('disableAffiliationCode') === 'true') {
      this.affiliationCode.disable();
    }
    this.activatedRoute.queryParams.subscribe(params => {
      const code = this.urlUtil.getQueryParamCaseInsensitive(params, 'affiliationcode');
      if (code) {
        this.hideContinueWithoutCode = true;
        this.isAffiliationFromUrl = true;
        this.affiliationCode.patchValue(code, { emitEvent: false });
        sessionStorage.setItem('affiliationCode', code);
        this.validateAffiliationCode(code);
        return;
      }
    });
    const storedCode = sessionStorage.getItem('affiliationCode');
    console.log('Stored affiliationCode:', storedCode);
    // Skip when the code came from the URL, otherwise it is validated twice
    // and the affiliation box flashes enabled before greying out.
    // Also skip when recovering into the forced workplace step - the code was
    // already validated this session, and re-validating wipes the just-restored
    // selectedCategory/selectedRole via resetEligibilitySelectionState().
    if (storedCode && !this.isAffiliationFromUrl && !isForceWorkplaceRecovery) {
      this.affiliationCode.patchValue(storedCode);
      this.validateAffiliationCode(storedCode);
    } else if (storedCode && isForceWorkplaceRecovery) {
      this.affiliationCode.patchValue(storedCode, { emitEvent: false });
    }
    this.affiliationCode.valueChanges.subscribe(value => {
      if (this.continueWithoutAffiliation) {
        return;
      }
      this.isAffiliationCodeValid = false; // reset on typing
      this.isRapidSosFlow = false;
      this.rapidSosOrgs = [];
      this.resetEligibilitySelectionState(true);
      this.updateDropdownDisabledStates();
    });
    this.customerEligibility = new UntypedFormGroup({
      selectCategory: this.selectCategory,
      selectRole: this.selectRole
    });
    if (this.isAffiliationFlow) {
      const rawOrg = sessionStorage.getItem('orgDetailInfo');
      if (rawOrg && rawOrg !== 'undefined') {
        try {
          const orgDetail = JSON.parse(rawOrg);
          this.isPSEAffliationcode = orgDetail?.isPSEAffliationcode;
          console.log('ngOnInit:isEVSP: ' + this.isEVSP);
        }
        catch {
          console.warn('Invalid orgDetailInfo JSON:', rawOrg);
        }
      }
    }
    if (!this.isAffiliationFlow) {
      this.getEntityList();
    }
    const raw = sessionStorage.getItem('eligibilityInfo');
    if (raw && raw !== 'undefined') {
      let eligibilityInformation;

      try {
        eligibilityInformation = JSON.parse(raw);
      } catch (e) {
        console.warn('Invalid eligibilityInfo JSON:', raw);
        return;
      }
      if (!eligibilityInformation || !eligibilityInformation.eligibilityStatus) {
        console.warn("eligibilityStatus missing");
        return;
      }
      if (eligibilityInformation.action === 'Profile Info' || this.action) {
        this.showCategory = false;
        this.showRole = false;
        this.showEditIcons = true;
        this.hideButtons = false;
        this.showIneligibility = false;
        this.showWorkplace = false;
        this.selectedRole = eligibilityInformation.selectedRole;
        this.selectedCategory = eligibilityInformation.entity;
        this.selectCategory.setValue(eligibilityInformation.entity);
        this.selectedJobFunctionDetails = eligibilityInformation.selectedJobFunctionDetails;
        this.roleList = eligibilityInformation.rolelist;
        const es = eligibilityInformation.eligibilityStatus || {};

        const eligibilityStatus = {
          selectedName: es.selectedName || '',
          org_name: es.selectedName || '',
          selectedAddress: es.selectedAddress || '',
          address: es.selectedAddress || '',
          selectedCity: es.selectedCity || '',
          city: es.selectedCity || '',
          selectedStateInWorkplace: es.selectedStateInWorkplace || '',
          state: es.selectedStateInWorkplace || '',
          selectedState: es.selectedStateInWorkplace && es.selectedStateInWorkplace.includes(':')
            ? es.selectedStateInWorkplace.split(':')[1]
            : es.selectedStateInWorkplace || '',
          selectedZipInWorkplace: es.selectedZipInWorkplace || '',
          selectedZip: es.selectedZipInWorkplace || '',
          zipcode: es.selectedZipInWorkplace || '',
          searchedResult: es.searchResults || []
        };
        this.checkstateAndZip(eligibilityStatus);
        this.hideWorkplaceSection(true);
        const eligibilityInfo = {
          'editIconSelected': true,
          selectedRole: this.selectedRole,
          entity: this.selectedCategory,
          eligibilityStatus: eligibilityStatus,
          type: eligibilityInformation.type,
          status: eligibilityInformation.status
        };
        sessionStorage.removeItem('eligibilityInfo');
        this.eligibilitycompletionstatus.emit(eligibilityInfo);
      }
    }
    this.activatedRoute.queryParams.subscribe((params) => {
      this.setReturnUrlAndCidToSessionStorage(params);
    });
  }

  setReturnUrlAndCidToSessionStorage(params) {
    if ((params && params['returnURL']) || (params && params['c_id_available'])) {
      this.returnUrl = this.sanitizeReturnUrl(params['returnURL']);
      this.cId = params['c_id_available'];
    }
    if ((this.returnUrl && this.returnUrl !== '') || (this.cId && this.cId !== '')) {
      sessionStorage.setItem('returnUrl', JSON.stringify(this.returnUrl));
      sessionStorage.setItem('c_id', JSON.stringify(this.cId));
    }
    if (params && params['app'] && params['app'] !== 0 && params['app'] === 'IDP') {
      this.openPopup = true;
      setTimeout(() => {
        this.openPopUpUtf = 'open';
      }, 1000);
    }
  }

  // for capturing the browser back button event
  // @HostListener('window: popstate', ['$event'])
  // onPopState(event: Event): void {
  //   event.preventDefault();
  //   if (this.showRole === true) {
  //     this.editCategory({ key: 'Enter' });
  //   } else if (this.showCategory) {
  //     if (sessionStorage.getItem('returnUrl') && Object.keys(sessionStorage.getItem('returnUrl').length !== 0)) {
  //       this.url = JSON.parse(sessionStorage.getItem('returnUrl'));
  //       this.redirectUrlFn(this.url);
  //       sessionStorage.clear();
  //     } else {
  //       this.location.back();
  //     }
  //   } else if (this.showConfirmRole && this.hideButtons) {
  //     this.editQA({ key: 'Enter' });
  //   } else if (this.showConfirmRole && this.showWorkplace) {
  //     if (this.child.showStateZipSection === false) {
  //       this.showEditIcons = false;
  //       this.child.editStateZip({ key: 'Enter' });
  //     } else {
  //       this.displayQAndA({ key: 'Enter' });
  //     }
  //   } else {
  //     this.location.back();
  //   }
  //   window.scrollTo(0, 0);
  // }

  ngOnChanges() {
    if (this.editButtonClicked) {
      this.showCategory = false;
      this.showRole = false;
      this.showConfirmRole = true;
      this.hideButtons = false;
      this.showIneligibility = false;
      this.showWorkplace = true;
      this.showEditIcons = false;
    }
  }
  onCategorySelected(event: any) {
    this.selectedCategory = event.value;
    this.roleValue = { value: '', text: 'Select' };
    this.selectRole.setValue('');
    this.selectedRole = '';
    this.showConfirmCheckbox = false;
    this.showCheckboxQA = false;
    this.showConfirmRole = false;
    this.selectedJobQuestions = [];
    this.selectedconfirmValue = [];
    this.showWorkplace = false;
    this.showEditIcons = false;
    this.showIneligibility = false;
    this.selectedJobFunctionDetails = [];
    if (!this.responderCategoriesresponse) return;
    this.jobfunctionentity = JSON.parse(JSON.stringify(this.responderCategoriesresponse));
    for (const job in this.jobfunctionentity) {
      if (this.selectedCategory === job) {
        let jobArray = this.jobfunctionentity[job];
        if (this.isAffiliationFlow && !this.isPSEAffliationcode) {
          jobArray = jobArray.filter(item =>
            !item.exclude_orgs ||
            !item.exclude_orgs.includes('isSpaOrg:True')
          );
        }
        if (this.continueWithoutAffiliation && !this.isAffiliationFlow) {
          jobArray = jobArray.filter(item =>
            (item.responder_sub_category || '')
              .trim()
              .toLowerCase() !== 'emergency management plan personnel'
          );
          jobArray = jobArray.filter(item => !this.isOnlyAgencyVerified(item));
        }
        jobArray = this.filterJobsByAffiliationFanType(jobArray, job);

        // 👇 IMPORTANT — Rebuild exactly like OLD WORKING CODE
        this.selectedJobFunctionDetails = jobArray.map(jobDetails => ({
          jobCategory: jobDetails.responder_sub_category,
          note: jobDetails.note,
          questions: jobDetails.questions,
          type: jobDetails.type,
          userType: jobDetails.user_type,
          subType: jobDetails.subtype,
          status: jobDetails.status,
          documents: jobDetails.documents
        }));

        this.roleList = jobArray.map(jobVal => ({
          value: jobVal.responder_sub_category,
          text: jobVal.responder_sub_category
        }));
      }
    }

    this.roleList.sort((a, b) =>
      a.value.localeCompare(b.value)
    );
    this.updateDropdownDisabledStates();
  }
  validateAffiliationCode(code = this.affiliationCode.value) {
    if (!code) {
      return;
    }

    if (this.continueWithoutAffiliation) {
      return;
    }
    if ((code || '').trim().toUpperCase() ===
      CustomerEligibilityUtfFormComponent.RAPIDSOS_AFFILIATION_CODE) {
      this.handleRapidSosAffiliation(code);
      return;
    }
    this.showLoading = true;
    this.isAffiliationCodeValid = false;
    this.updateDropdownDisabledStates();
    this.logCategoryFlowState('AFFILIATION_VALIDATE_START', { code });
    const param = { retcode: code };
    const url = this.urlUtil.formatURlParams(CFETILMEndpointsConstant.GET_AFFILIATION_CODE, param);
    this.cfetService.cfetLiveGet('', url).subscribe((data: any) => {
      if (data && data.profile && data.profile.length > 0) {
        this.isAffiliationCodeValid = true;
        this.updateDropdownDisabledStates();
        sessionStorage.setItem('hideContinueWithoutCode', 'true');
        this.isAffiliationFlow = true;
        this.logCategoryFlowState('BEFORE_RESET_AFTER_AFFILIATION_SUCCESS');
        this.resetEligibilitySelectionState(true);
        this.logCategoryFlowState('AFTER_RESET_BEFORE_FILTER_REBUILD');
        if (this.isAffiliationFromUrl) {
          this.affiliationCode.disable({ emitEvent: false });
          sessionStorage.setItem('disableAffiliationCode', 'true');
          sessionStorage.setItem('affiliationCode', code);
          // Persist org details so the confirmation page renders from session
          // instead of re-fetching, which previously left its spinner running.
          let isSpaOrgFromUrl = false;
          (data.profile || []).forEach((val: any) => {
            if (val.attribute_name === 'isSpaOrg' && val.attribute_value === 'TRUE') {
              isSpaOrgFromUrl = true;
            }
          });
          sessionStorage.setItem('orgInfo', JSON.stringify({
            orgid: data.orgid,
            orgName: data.orgName,
            isSpaOrg: isSpaOrgFromUrl,
            affiliationCode: code
          }));
          this.router.navigate(
            [CfetPageNamesConstant.AFFILIATION_CODE_UTF],
            { replaceUrl: true }
          );
          this.setLoading(false);
          return;
        }
        this.orgId = data.orgid;
        const matchedFan =
          (data.fan || []).find(
            (f: any) =>
              (f?.retCode || '').trim().toLowerCase() ===
              (code || '').trim().toLowerCase()
          );
        this.affiliationFanTypes =
          matchedFan?.types || data.fan?.[0]?.types || [];

        this.affiliationResponderJobs =
          data.responderJob || [];

        console.log(
          'STORED FAN TYPES =>',
          this.affiliationFanTypes
        );

        console.log(
          'STORED RESPONDER JOBS =>',
          this.affiliationResponderJobs
        );
        const param = { xorgid: this.orgId };
        const orgUrl = this.urlUtil.formatURlParams(CFETILMEndpointsConstant.GET_ORG_PROFILE, param);
        this.cfetService.cfetLiveGet('', orgUrl).subscribe((orgData: any) => {
          console.log('ORG API (early):', orgData);
          this.orgProfileData = orgData;
          let isEVSP = false;
          if (orgData && orgData.profile) {
            orgData.profile.forEach(val => {
              if (
                val.attribute_name === 'isEVSP' &&
                val.attribute_value === 'TRUE'
              ) {
                isEVSP = true;
              }
            });
          }
          this.isEVSP = isEVSP;
          this.logCategoryFlowState('BEFORE_REBUILD_CATEGORY_LIST', {
            isEVSP: this.isEVSP,
            fanTypesCount: (this.affiliationFanTypes || []).length,
            responderJobsCount: (this.affiliationResponderJobs || []).length
          });
          this.categoryList = [];
          this.rebuildCategoryListFromExistingData();
          this.logCategoryFlowState('AFTER_REBUILD_CATEGORY_LIST', {
            firstThreeCategories: (this.categoryList || []).slice(0, 3)
          });
          console.log("ORG ID FROM AFFILIATION:", this.orgId);
          this.setLoading(false);
        }, (_orgError) => {
          this.setLoading(false);
        });

        data.profile.forEach(val => {
          if (
            val.attribute_name === 'isSpaOrg' &&
            val.attribute_value === 'TRUE'
          ) {
            this.isSpaOrg = true;
          }

        });
        this.isPSEAffliationcode = true;
        this.updateDropdownDisabledStates();
      } else {
        this.setLoading(false);
        this.isAffiliationCodeValid = false;
        this.updateDropdownDisabledStates();
        this.hideContinueWithoutCode = false;
        sessionStorage.removeItem('hideContinueWithoutCode');
        sessionStorage.removeItem('disableAffiliationCode');
        this.affiliationCode.enable();
        this.showBadCodeModal = true;
        setTimeout(() => {
          this.openBadCodeModal = 'open';
        }, 0);
        return;
      }
    }, (_error) => {
      this.setLoading(false);
      this.isAffiliationCodeValid = false;
      this.updateDropdownDisabledStates();
      this.hideContinueWithoutCode = false;
      sessionStorage.removeItem('hideContinueWithoutCode');
      sessionStorage.removeItem('disableAffiliationCode');
      this.affiliationCode.enable();
      if (!this.continueWithoutAffiliation) {
        this.showBadCodeModal = true;
        setTimeout(() => {
          this.openBadCodeModal = 'open';
        }, 0);
      }
    });
  }
  private handleRapidSosAffiliation(code: string): void {
    this.isRapidSosLoading = true;
    this.showLoading = true;
    this.isAffiliationCodeValid = false;
    this.logCategoryFlowState('RAPIDSOS_VALIDATE_START', { code });
    const requestParam = {
      search_criteria: [
        {
          attribute_name: 'isRapidSOS',
          attribute_value: 'TRUE'
        },
        {
          attribute_name: 'isSpaOrg',
          attribute_value: 'TRUE'
        }
      ]
    };
    this.cfetService.cfetLivePost(requestParam, CFETILMEndpointsConstant.SEARCH_DETAILS)
      .subscribe((data: any) => {
        const orgs = this.extractRapidSosOrgs(data);
        if (!orgs.length) {
          this.handleRapidSosFailure();
          return;
        }
        forkJoin(orgs.map((org: any) => this.buildRapidSosOrgRecord(org)))
          .subscribe((records: any[]) => {
            const validRecords = (records || []).filter(
              r => r && Array.isArray(r.fanTypes) && r.fanTypes.length
            );
            if (!validRecords.length) {
              this.handleRapidSosFailure();
              return;
            }
            this.applyRapidSosRecords(validRecords, code);
          }, () => this.handleRapidSosFailure());
      }, () => this.handleRapidSosFailure());
  }

  private extractRapidSosOrgs(data: any): any[] {
    if (Array.isArray(data)) {
      return data;
    }
    if (data?.orgs) {
      return data.orgs;
    }
    if (data && (data.orgid || data.fan)) {
      return [data];
    }
    return [];
  }

  private applyRapidSosRecords(records: any[], code: string): void {
    this.rapidSosOrgs = records;
    this.isRapidSosFlow = true;
    this.isAffiliationFlow = true;
    this.isAffiliationCodeValid = true;
    this.isPSEAffliationcode = true;
    // Categories/roles from BOTH orgs are shown, so do not hide anything by EVSP
    // during the merged selection; EVSP is applied per-org at continue time.
    this.isEVSP = false;
    this.orgId = null;
    this.orgProfileData = null;
    sessionStorage.setItem('hideContinueWithoutCode', 'true');
    sessionStorage.setItem('affiliationCode', code);
    // Drive the category/role dropdowns strictly from the org type(s) the
    // org-search response actually declares for each org (profile "orgType").
    // If the org is only "Primary Subscriber Paid", the dropdowns show Primary
    // only; Extended Primary appears only when the org actually declares it.
    const mergedFanTypes: string[] = [];
    records.forEach(record => {
      (record.fanTypes || []).forEach((type: string) => {
        if (type && !mergedFanTypes.includes(type)) {
          mergedFanTypes.push(type);
        }
      });
    });
    this.affiliationFanTypes = mergedFanTypes;
    this.affiliationResponderJobs = [];
    this.resetEligibilitySelectionState(true);
    sessionStorage.setItem('disableAffiliationCode', 'true');
    this.selectCategory.enable();
    this.selectRole.enable();
    this.rebuildCategoryListFromExistingData();
    this.affiliationCode.disable({ emitEvent: false });
    this.isRapidSosLoading = false;
    this.setLoading(false);
    this.cd.detectChanges();
    this.logCategoryFlowState('RAPIDSOS_VALIDATE_DONE', {
      mergedFanTypes,
      orgCount: records.length
    });
  }

  private buildRapidSosOrgRecord(org: any): Observable<any> {
    const directFanTypes = this.extractOrgFanTypes(org);
    const directRetCode = this.extractOrgRetCode(org);
    if (directFanTypes.length && directRetCode) {
      return of(this.assembleRapidSosRecord(org, directFanTypes, directRetCode, org));
    }
    if (!org?.orgid) {
      return of(this.assembleRapidSosRecord(org, directFanTypes, directRetCode, org));
    }
    const param = { xorgid: org.orgid };
    const url = this.urlUtil.formatURlParams(CFETILMEndpointsConstant.GET_ORG_PROFILE, param);
    return this.cfetService.cfetLiveGet('', url).pipe(
      map((profileData: any) => {
        const fanTypes = directFanTypes.length ? directFanTypes : this.extractOrgFanTypes(profileData);
        const retCode = directRetCode || this.extractOrgRetCode(profileData);
        return this.assembleRapidSosRecord(org, fanTypes, retCode, profileData);
      })
    );
  }

  private assembleRapidSosRecord(
    searchOrg: any,
    fanTypes: string[],
    retCode: string,
    profileSource: any
  ): any {
    const profile = profileSource?.profile || searchOrg?.profile || [];
    const resolvedFanTypes = fanTypes || [];
    return {
      orgid: searchOrg?.orgid || profileSource?.orgid,
      orgName: searchOrg?.org_name || profileSource?.orgName || profileSource?.org_name || '',
      profile,
      // orgProfileData is consumed by getOrgProfile() when this org is selected.
      orgProfileData: profileSource,
      fanTypes: resolvedFanTypes,
      retCode: retCode || '',
      // Resolve FAN up front; setFanNumber/addUser in the next step read this via orgInfo.fanName.
      fanName: this.resolveOrgFanName(profileSource, resolvedFanTypes)
        || this.resolveOrgFanName(searchOrg, resolvedFanTypes),
      isEVSP: this.hasProfileAttributeTrue(profile, 'isEVSP'),
      isSpaOrg: this.hasProfileAttributeTrue(profile, 'isSpaOrg')
    };
  }

  // RapidSOS FAN can arrive as "FAN" (org-profile) or "fan" (org-search).
  private extractFanArray(source: any): any[] {
    if (Array.isArray(source?.fan)) {
      return source.fan;
    }
    if (Array.isArray(source?.FAN)) {
      return source.FAN;
    }
    return [];
  }

  // Match a FAN entry to the org's declared type(s); fall back to the first FAN entry.
  private resolveOrgFanName(source: any, orgFanTypes: string[]): string {
    const fanArray = this.extractFanArray(source);
    if (!fanArray.length) {
      return '';
    }
    const normalizedOrgTypes = (orgFanTypes || []).map((type: string) =>
      type
        .replace(/subscriber paid/ig, '')
        .trim()
        .toLowerCase()
    );
    const matchedFan =
      fanArray.find((f: any) =>
        (f?.types || []).some(
          (type: string) =>
            normalizedOrgTypes.includes(
              type
                .replace(/subscriber paid/ig, '')
                .trim()
                .toLowerCase()
            )
        )
      ) || fanArray.find((f: any) => f?.fan);
    return matchedFan?.fan || '';
  }

  private extractOrgFanTypes(source: any): string[] {
    // The org's declared type (profile "orgType") is the source of truth for
    // which categories/jobs are eligible. Only fall back to the FAN type list
    // when the org profile does not declare an orgType.
    const orgTypes = this.extractOrgTypesFromProfile(source);
    if (orgTypes.length) {
      return orgTypes;
    }
    const fanArray = Array.isArray(source?.fan) ? source.fan : [];
    const types: string[] = [];
    fanArray.forEach((fanEntry: any) => {
      (fanEntry?.types || []).forEach((type: string) => {
        if (type) {
          types.push(type);
        }
      });
    });
    return types;
  }

  private extractOrgTypesFromProfile(source: any): string[] {
    const profile = Array.isArray(source?.profile) ? source.profile : [];
    const orgTypeAttr = profile.find(
      (attr: any) => attr?.attribute_name === 'orgType'
    );
    if (!orgTypeAttr) {
      return [];
    }
    const raw = orgTypeAttr.attribute_mvalue ?? orgTypeAttr.attribute_value;
    if (Array.isArray(raw)) {
      return raw.filter((type: any) => !!type);
    }
    return raw ? [raw] : [];
  }

  private extractOrgRetCode(source: any): string {
    const fanArray = Array.isArray(source?.fan) ? source.fan : [];
    const fanWithRetCode = fanArray.find((fanEntry: any) => fanEntry?.retCode);
    return fanWithRetCode?.retCode || source?.retCode || '';
  }

  private hasProfileAttributeTrue(profile: any[], attributeName: string): boolean {
    return Array.isArray(profile)
      && profile.some(
        (attr: any) =>
          attr?.attribute_name === attributeName
          && String(attr?.attribute_value).toUpperCase() === 'TRUE'
      );
  }

  private handleRapidSosFailure(): void {
    this.isRapidSosLoading = false;
    this.setLoading(false);
    this.isRapidSosFlow = false;
    this.rapidSosOrgs = [];
    this.isAffiliationCodeValid = false;
    this.hideContinueWithoutCode = false;
    sessionStorage.removeItem('hideContinueWithoutCode');
    sessionStorage.removeItem('disableAffiliationCode');
    this.affiliationCode.enable();
    this.updateDropdownDisabledStates();
    // Same "We don't know that code" bad-code popup as an unmatched affiliation code.
    this.showBadCodeModal = true;
    setTimeout(() => {
      this.openBadCodeModal = 'open';
    }, 0);
  }

  // Picks the RapidSOS org (primary vs extended primary) that matches the
  // selected role's user type, so the correct org is used to continue.
  private applyRapidSosOrgSelection(): void {
    if (!this.isRapidSosFlow) {
      return;
    }
    let userType = this.userType;
    if (!userType) {
      const selectedJob = (this.selectedJobFunctionDetails || []).find(
        (job: any) => job.jobCategory === this.selectedRole
      );
      userType = selectedJob?.userType || '';
    }
    const normalizedUserType = (userType || '')
      .replace(/subscriber paid/ig, '')
      .trim()
      .toLowerCase();
    const matchedOrg =
      (this.rapidSosOrgs || []).find(record =>
        (record.fanTypes || []).some(
          (type: string) =>
            type
              .replace(/subscriber paid/ig, '')
              .trim()
              .toLowerCase() === normalizedUserType
        )
      ) || (this.rapidSosOrgs || [])[0];
    if (!matchedOrg) {
      return;
    }
    this.orgId = matchedOrg.orgid;
    this.orgProfileData = matchedOrg.orgProfileData;
    this.isEVSP = !!matchedOrg.isEVSP;
    // RapidSOS orgs are always SPA orgs, even when their profile omits the isSpaOrg attribute.
    this.isSpaOrg = true;
    // FAN was resolved per-org at build time (assembleRapidSosRecord).
    this.rapidSosResolvedFan = matchedOrg.fanName || '';
    // RapidSOS skips getOrgProfile() (goes to the workplace step instead), so persist orgInfo here
    // or the info page has no org to use and falls back to a wrong job-function search.
    const rapidSosOrgInfo = {
      orgProfileInfo: matchedOrg.orgProfileData,
      orgid: matchedOrg.orgid,
      orgName: matchedOrg.orgName,
      isSpaOrg: true,
      affiliationCode: matchedOrg.retCode || '',
      isRapidSOS: true,
      fanName: matchedOrg.fanName || ''
    };
    sessionStorage.setItem('orgInfo', JSON.stringify(rapidSosOrgInfo));
    if (matchedOrg.retCode) {
      // Do not emit, otherwise valueChanges would reset the selection state.
      this.affiliationCode.setValue(matchedOrg.retCode, { emitEvent: false });
    }
    this.logCategoryFlowState('RAPIDSOS_ORG_SELECTED', {
      selectedUserType: userType,
      selectedOrgId: this.orgId,
      selectedRetCode: matchedOrg.retCode,
      resolvedFan: this.rapidSosResolvedFan
    });
  }

  private resetEligibilitySelectionState(clearCategoryList = false): void {
    this.selectCategory?.setValue('');
    this.selectRole?.setValue('');
    this.categoryValue = { value: '', text: 'Select' };
    this.roleValue = { value: '', text: 'Select' };
    this.selectedCategory = '';
    this.selectedRole = '';
    this.roleList = [];
    if (clearCategoryList) {
      this.categoryList = [];
    }
    this.selectedJobFunctionDetails = [];
    this.displayNote = false;
    this.messageNote = '';
    this.selectedJobQuestions = [];
    this.selectedconfirmValue = [];
    this.selectedconfirmValueExt = [];
    this.showCheckboxQA = false;
    this.showConfirmCheckbox = false;
    this.hideButtons = true;
    this.checkCategory = '';
    this.checkRole = '';
    this.showIneligibility = false;
    this.disableCategoryContinueButton = true;
    this.disableRoleContinueButton = true;
    this.updateDropdownDisabledStates();
  }
  closeBadCodePopup() {
    this.openBadCodeModal = 'close';
    this.showBadCodeModal = false;
  }
  getOrgProfile() {
    if (!this.orgId) {
      return;
    }
    const data = this.orgProfileData;
    if (!data) {
      console.warn('Org data not ready yet');
      return;
    }
    this.setLoading(false);

    if (data && data.profile) {
      const companyInfo: any = {};

      data.profile.forEach(val => {
        companyInfo[val.attribute_name] =
          val.attribute_value ?? val.attribute_mvalue;
      });
      const oraRequired = data.profile.find(
        x => x.attribute_name === 'ora_required'
      );

      const oraAttributes = data.profile.find(
        x => x.attribute_name === 'ora_required_attributes'
      );

      const oraInfo = {
        ora_required: oraRequired?.attribute_value || 'N',
        ora_required_attributes: oraAttributes?.attribute_mvalue || []
      };
      sessionStorage.setItem('oraInformation', JSON.stringify(oraInfo));
      const addressLine2 = companyInfo['Address 2'] || '';

      const streetAddress = addressLine2
        ? `${companyInfo['Address 1']}, ${addressLine2}`
        : companyInfo['Address 1'];

      const orgDetailInfo = {
        org_name: data.orgName || data.org_name,
        address: streetAddress,
        city: companyInfo['city'],
        state: companyInfo['state'],
        zipcode: companyInfo['zipcode'],
        selectedName: data.orgName,
        selectedAddress: streetAddress,
        selectedCity: companyInfo['city'],
        selectedStateInWorkplace: companyInfo['state'],
        selectedZipInWorkplace: companyInfo['zipcode'],

        isPSEAffliationcode: true
      };

      sessionStorage.setItem(
        'orgDetailInfo',
        JSON.stringify(orgDetailInfo)
      );
      sessionStorage.setItem('agencyNameSource', 'affiliationCode');
      sessionStorage.setItem('agencyName', orgDetailInfo.org_name);
      const orgInfo = {
        orgProfileInfo: data,
        orgid: data.orgid || this.orgId,
        orgName: orgDetailInfo.org_name,
        isSpaOrg: this.isSpaOrg || false,
        affiliationCode: this.affiliationCode?.value || '',
        // RapidSOS orgs often have no retCode, so affiliationCode alone can't identify this flow downstream.
        isRapidSOS: this.isRapidSosFlow,
        // Pre-resolved FAN for RapidSOS orgs, which have no retCode to match on later.
        fanName: this.isRapidSosFlow ? this.rapidSosResolvedFan : ''
      };
      sessionStorage.setItem('orgInfo', JSON.stringify(orgInfo));
      console.log("AFFILIATION FLOW → orgInfo set:", orgInfo);
      const eligibilityInfo: any = {
        selectedRole: this.selectedRole,
        entity: this.selectedCategory || sessionStorage.getItem('selectedCategory') || '',
        eligibilityStatus: {
          completionStatus: true,
          selectedName: orgDetailInfo.org_name || '',
          selectedAddress: orgDetailInfo.address || '',
          selectedCity: orgDetailInfo.city || '',
          selectedStateInWorkplace: orgDetailInfo.state || '',
          selectedZipInWorkplace: orgDetailInfo.zipcode || ''
        },
        action: 'eligibility',
        selectedJobFunctionDetails: this.selectedJobFunctionDetails,
        rolelist: this.roleList
      };

      this.selectedJobFunctionDetails.forEach(element => {
        if (element.jobCategory === this.selectedRole) {
          eligibilityInfo.type = element.type;
          eligibilityInfo.userType = element.userType;
          eligibilityInfo.subType = element.subType;
          eligibilityInfo.status = element.status;
          eligibilityInfo.documents = element.documents;
          eligibilityInfo.questions = element.questions;
          eligibilityInfo.note = element.note;
        }
      });

      sessionStorage.setItem('eligibilityInfo', JSON.stringify(eligibilityInfo));
      this.eligibilitycompletionstatus.emit(eligibilityInfo);
      this.showEligibilityCompletion = true;
      this.checkstateAndZip(orgDetailInfo);
      this.showRole = false;
      this.showConfirmRole = true;
      this.showConfirmedUserRole = false;
      this.showWorkplace = false;
      this.hideButtons = false;
      this.progressTrackerEvent.emit('EligibilityCompletion');
      this.isRoleSelected.emit(true);
      this.router.navigate([
        CfetPageNamesConstant.CUSTOMER_ELIGIBILITY_UTF,
        'completion'
      ]);
    }


  }
  onSubmitAffiliationCode(event: any) {

    if (event.type === 'click' || event.key === 'Enter') {

      if (!this.affiliationCode.value) {
        return;
      }

      this.setLoading(true);

      const param = { retcode: this.affiliationCode.value };
      const url = `${CFETILMEndpointsConstant.GET_AFFILIATION_CODE}?retcode=${this.affiliationCode.value}`;

      this.cfetService.cfetLiveGet('', url).subscribe((data: any) => {

        this.setLoading(false);

        if (data && data.profile) {
          data.profile.forEach(val => {
            if (val.attribute_name === 'isSpaOrg' && val.attribute_value === 'TRUE') {
              this.isSpaOrg = true;
            }
          });
        }

        console.log('Affiliation validated successfully');

      }, (_error) => {
        this.setLoading(false);
        console.log('Invalid affiliation code');
      });
    }
  }
  onBadCodeModalClosed(event) {
    if (this.openBadCodeModal === 'close') {
      this.closeBadCodePopup();
    }
  }
  toggleAffiliationField() {
    // 🔄 Reset affiliation validation
    this.closeBadCodePopup();
    this.isAffiliationCodeValid = false;
    this.isAffiliationFlow = false;
    this.isRapidSosFlow = false;
    this.rapidSosOrgs = [];
    this.isEVSP = false;
    this.categoryList = [];
    this.rebuildCategoryListFromExistingData();
    this.isPSEAffliationcode = false;
    this.orgId = null;

    // 🔄 Clear affiliation input
    if (this.continueWithoutAffiliation) {
      this.verificationTypeChange.emit(null);
      this.affiliationCode.setValue('');
      this.affiliationCode.disable();
      this.isAffiliationCodeValid=false;
      this.openBadCodeModal= 'close';
      sessionStorage.removeItem('affiliationCode');
    } else {
      this.affiliationCode.enable();
      this.verificationTypeChange.emit(null);
    }
    // this.isEVSP = false;
    // this.isPSEAffliationcode = false;
    // this.categoryList = [];
    // this.getEntityList();
    // 🔄 Clear category & role selections
    this.selectCategory.setValue('');
    this.selectRole.setValue('');
    this.categoryValue = { value: '', text: 'Select' };
    this.roleValue = { value: '', text: 'Select' };
    this.updateDropdownDisabledStates();

    this.selectedCategory = '';
    this.selectedRole = '';
    this.roleList = [];
    //IMPORTANT: Reset QA / note section
    this.displayNote = false;
    this.messageNote = '';
    this.selectedJobQuestions = [];
    this.selectedconfirmValue = [];
    this.selectedconfirmValueExt = [];
    this.showCheckboxQA = false;
    this.showConfirmCheckbox = false;

    // 🔄 Reset QA + workplace flags
    this.showRole = false;
    this.showConfirmRole = false;
    this.showConfirmedUserRole = false;
    this.showWorkplace = false;
    this.showEditIcons = false;
    this.showIneligibility = false;

    // 🔄 Clear state & zip
    this.stateAndZip = {
      state: '',
      zipcode: ''
    };
    this.manuallyEnteredValues = null;

    // 🔄 Remove stored org data
    sessionStorage.removeItem('orgDetailInfo');

    // 🔄 Reset button state
    this.hideButtons = true;
  }

  get isAffiliationValid(): boolean {
    return this.continueWithoutAffiliation || this.isAffiliationCodeValid;
  }

  getMatchedResponderJobNamesByFanType(
    matchedResponderJob: any,
    normalizedFanTypes: string[]
  ): string[] {
    const rawJobs =
      matchedResponderJob?.responderJobList
      || matchedResponderJob?.firstResponderJobs
      || [];

    return rawJobs
      .filter((rj: any) => {
        const normalizedResponderUserType =
          (rj?.user_type || '')
            .replace(/subscriber paid/ig, '')
            .trim()
            .toLowerCase();

        if (!normalizedResponderUserType) {
          return true;
        }

        return normalizedFanTypes.includes(normalizedResponderUserType);
      })
      .map((rj: any) =>
        (rj?.jobName || '')
          .trim()
          .toLowerCase()
      );
  }
  private filterJobsByAffiliationFanType(jobArray: any[], categoryName: string): any[] {
    if (!this.isAffiliationFlow || !Array.isArray(jobArray)) {
      return (jobArray || []).filter((item: any) => !this.shouldHideJobForEVSP(item));
    }
    // SPA org (incl. RapidSOS, always SPA) -> role dropdown only shows jobs whose
    // subpaid_program allows self verification. Jobs that are only "Agency Verified" are hidden.
    if (this.isSpaAffiliationOrg()) {
      jobArray = jobArray.filter((item: any) => !this.isOnlyAgencyVerified(item));
    }
    const normalizedFanTypes =
      (this.affiliationFanTypes || []).map((type: string) =>
        type
          .replace(/subscriber paid/ig, '')
          .trim()
          .toLowerCase()
      );
    if (!normalizedFanTypes.length) {
      return jobArray;
    }

    const matchedResponderJob =
      (this.affiliationResponderJobs || []).find(
        (job: any) =>
          (job.categoryName || '')
            .trim()
            .toLowerCase() ===
          (categoryName || '')
            .trim()
            .toLowerCase()
      );

    const responderJobsEmpty = (this.affiliationResponderJobs || []).length === 0;
    // Org has selected job titles for other categories but none for this category -> show nothing here.
    if (!responderJobsEmpty && !matchedResponderJob) {
      return [];
    }

    const responderJobNames = !responderJobsEmpty
      ? this.getMatchedResponderJobNamesByFanType(
        matchedResponderJob,
        normalizedFanTypes
      )
      : [];

    return jobArray.filter((item: any) => {
      if (this.shouldHideJobForEVSP(item)) {
        return false;
      }
      const normalizedUserType =
        (item.user_type || '')
          .replace(/subscriber paid/ig, '')
          .trim()
          .toLowerCase();
      const fanTypeMatches = normalizedFanTypes.includes(normalizedUserType);
      // Org has NO selected job titles -> show every firstResponderJobs entry matching the FAN type.
      if (responderJobsEmpty) {
        return fanTypeMatches;
      }
      // Org HAS selected job titles -> restrict to the org's selection that also matches the FAN type.
      const normalizedJobName =
        (item.responder_sub_category || '')
          .trim()
          .toLowerCase();
      return fanTypeMatches && responderJobNames.includes(normalizedJobName);
    });
  }

  private isOnlyAgencyVerified(item: any): boolean {
    if (!Array.isArray(item?.subpaid_program)) {
      return false;
    }
    const programs = item.subpaid_program
      .map((p: any) => String(p || '').trim().toLowerCase())
      .filter((p: string) => p.length > 0);
    return programs.length === 1 && programs[0] === 'agency verified';
  }

  // RapidSOS orgs are always SPA orgs, so treat them as SPA for job filtering.
  private isSpaAffiliationOrg(): boolean {
    return this.isRapidSosFlow || this.isSpaOrg;
  }

  private isExcludedRapidSosCategory(categoryName: string): boolean {
    return (categoryName || '').trim().toLowerCase() === 'rapidsos';
  }

  private shouldHideJobForEVSP(item: any): boolean {
    if (!this.isEVSP || !item) {
      return false;
    }

    const rawUserCategory =
      item.user_category || item.userCategory || item.usercategory || '';
    const userCategory = String(rawUserCategory).trim().toLowerCase();
    if (userCategory === 'evsp') {
      return true;
    }

    if (!Array.isArray(item.subpaid_program)) {
      return false;
    }

    const normalizedPrograms = item.subpaid_program
      .map((p: any) => String(p || '').trim().toLowerCase())
      .filter((p: string) => p.length > 0);

    return (
      normalizedPrograms.length === 1
      && normalizedPrograms[0] === 'agency verified'
    );
  }

  rebuildCategoryListFromExistingData() {
  this.categoryList = [];
  if (!this.responderCategoriesresponse) {
    return;
  }
  for (const entity in this.responderCategoriesresponse) {
    const category = this.responderCategoriesresponse[entity];
    if (
      this.isAffiliationFlow
    ) {
      const normalizedFanTypes =
        (this.affiliationFanTypes || []).map(
          (type: string) =>
            type
              .replace(/subscriber paid/ig, '')
              .trim()
              .toLowerCase()
        );
      const matchedResponderJob =
        (this.affiliationResponderJobs || []).find(
          (job: any) =>
            job.categoryName
              ?.trim()
              .toLowerCase() ===
            entity
              ?.trim()
              .toLowerCase()
        );
      const responderJobsEmpty = (this.affiliationResponderJobs || []).length === 0;
      let hasMatchingFanType = false;
      if (Array.isArray(category)) {
        if (responderJobsEmpty) {
          hasMatchingFanType = category.some((item: any) => {
            if (this.shouldHideJobForEVSP(item)) {
              return false;
            }
            if (this.isSpaAffiliationOrg() && this.isOnlyAgencyVerified(item)) {
              return false;
            }
            const normalizedUserType =
              (item.user_type || '')
                .replace(/subscriber paid/ig, '')
                .trim()
                .toLowerCase();
            return normalizedFanTypes.includes(normalizedUserType);
          });
        } else {
          if (matchedResponderJob) {
            hasMatchingFanType = category.some((item: any) => {
              if (this.shouldHideJobForEVSP(item)) {
                return false;
              }
              if (this.isSpaAffiliationOrg() && this.isOnlyAgencyVerified(item)) {
                return false;
              }
              const normalizedUserType =
                (item.user_type || '')
                  .replace(/subscriber paid/ig, '')
                  .trim()
                  .toLowerCase();
              const normalizedJobName =
                (item.responder_sub_category || '')
                  .trim()
                  .toLowerCase();

              console.log('[EligibilityUTF] category userType check', {
                entity,
                rawJobName: item.responder_sub_category,
                rawUserType: item.user_type,
                normalizedUserType,
                normalizedFanTypes
              });

              const fanTypeMatches = normalizedFanTypes.includes(normalizedUserType);
              const responderJobNames =
                this.getMatchedResponderJobNamesByFanType(
                  matchedResponderJob,
                  normalizedFanTypes
                );
              return fanTypeMatches && responderJobNames.includes(normalizedJobName);
            });
          } else {
            hasMatchingFanType = false;
          }
        }
      }

      console.log('[EligibilityUTF] category match result', {
        entity,
        hasMatchedResponderJob: !!matchedResponderJob,
        hasMatchingFanType,
        responderJobsEmpty
      });

      if (hasMatchingFanType) {
        this.categoryList.push({
          value: entity,
          text: entity
        });
      }
      continue;
    }
    if (this.continueWithoutAffiliation) {
      const jobs = this.responderCategoriesresponse[entity];
      if (Array.isArray(jobs) && jobs.length > 0 && (jobs as any[]).every((item: any) => this.isOnlyAgencyVerified(item))) {
        continue;
      }
    }
    this.categoryList.push({
      value: entity,
      text: entity
    });
  }
  this.categoryList.sort((a, b) =>
    a.value.localeCompare(b.value)
  );
}
    editJobRole(e) {
      if (!this.showIneligibility) {
        if (e.key === 'Enter' || e.type === 'click') {
          this.showRole = true;
          this.showConfirmedUserRole = false;
          this.showConfirmRole = true;
          this.showWorkplace = false;
          this.showEditIcons = false;
          this.hideButtons = true;
          const editIconSelected = {
            editIconSelected: true
          };
          this.roleValue = { 'value': this.selectedRole, 'text': this.selectedRole };
          this.editSelected.emit(editIconSelected);
        }
      }
    }

    enableCategoryContinue(event) {
      this.disableCategoryContinueButton = false;
      this.checkCategory = '';
      this.customerEligibility.patchValue({
        selectCategory: event.value
      });
      this.selectedCategory = this.selectCategory.value;
    }

    onChangeCategory(event) {
      if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
        this.roleValue = { 'value': '', 'text': 'Select' };
        this.disableRoleContinueButton = true;
        if (this.selectCategory.value !== 'Select') {
          this.selectedJobFunctionDetails = [];
          this.jobfunctionentity = JSON.parse(JSON.stringify(this.responderCategoriesresponse));
          for (const job in this.jobfunctionentity) {
            if (this.selectCategory.value === job) {
              let jobArray = this.jobfunctionentity[job];
              if (!this.isPSEAffliationcode) {
                jobArray = jobArray.filter(item =>
                  !item.exclude_orgs ||
                  !item.exclude_orgs.includes('isSpaOrg:True')
                );
                console.log("AFTER NON-SPA FILTER:", jobArray);
              }
              if (this.continueWithoutAffiliation && !this.isAffiliationFlow) {
                jobArray = jobArray.filter(item =>
                  (item.responder_sub_category || '')
                    .trim()
                    .toLowerCase() !== 'emergency management plan personnel'
                );
                jobArray = jobArray.filter(item => !this.isOnlyAgencyVerified(item));
              }
              jobArray = jobArray.filter((item: any) => !this.shouldHideJobForEVSP(item));
              jobArray = this.filterJobsByAffiliationFanType(jobArray, this.selectCategory.value);
              this.roleList = jobArray.map(jobVal => ({
                value: jobVal.responder_sub_category,
                text: jobVal.responder_sub_category
              }));
              this.selectedJobFunctionDetails = jobArray.map(jobDetails => ({
                jobCategory: jobDetails.responder_sub_category,
                note: jobDetails.note,
                questions: jobDetails.questions,
                type: jobDetails.type,
                userType: jobDetails.user_type,
                subType: jobDetails.subtype,
                status: jobDetails.status,
                documents: jobDetails.documents
              }));
            }
          }
          this.roleList.sort(function (a, b) {
            return a['value'].localeCompare(b['value']);
          });

          this.displayNote = false;
          this.showCheckboxQA = false;
          this.showConfirmCheckbox = false;
        }
      }
    }

    // editCategory() {
    //   this.router.navigate([CfetPageNamesConstant.CUSTOMER_LANDING]);
    // }

    editQA(e) {
      if (e.key === 'Enter' || e.type === 'click') {
        this.indexCount = 0;
        this.indexNoCount = 0;
        this.indexYesCount = 0;
        this.selectedconfirmValueExt = [];
        this.showCategory = false;
        this.showRole = true;
        this.showConfirmRole = false;
        this.showCheckboxQA = false;
        this.isRoleSelected.emit(false);
        this.progressTrackerEvent.emit('roleDetails');
      }
    }

    @HostListener('document:click', ['$event']) clickout(event) {
      if (event.target.id !== 'select_category' && event.target.id !== 'select_role') {
        this.checkCategory = '';
        this.checkRole = '';
      }
    }

    enableContinue(event) {
      this.displayNote = true;
      let index = 0;
      this.showConfirmedUserRole = false;
      this.showConfirmCheckbox = false;
      this.showWorkplace = false;
      this.showEditIcons = false;
      this.selectedJobQuestions = [];
      this.selectedconfirmValue = [];
      this.showCheckboxQA = false;
      this.showConfirmRole = true;
      this.disableRoleContinueButton = false;
      this.customerEligibility.patchValue({
        selectRole: event.value
      });
      this.selectedRole = this.selectRole.value;
      this.roleSelected = this.selectRole.value.toLowerCase();
      this.checkRole = '';
      if (this.selectedRole !== 'Select') {
        this.selectedJobFunctionDetails.forEach(job => {
          if (this.roleSelected === job.jobCategory.toLowerCase()) {
            job.questions.forEach(ques => {
              this.selectedJobQuestions.push({ 'questionValue': ques, 'radioButtonNo': '' });
              index++;
            });
            this.messageNote = job.note;
            this.userType = job.userType;
            sessionStorage.setItem('userType', this.userType);
          }
        });
        if (this.messageNote === '') {
          this.showNote = false;
        } else {
          this.showNote = true;
        }
      }
      this.hideButtons = true;
    }

    checkIfAllQuestionsAnswered() {
      this.showConfirmCheckbox = this.selectedJobQuestions.every((_, index) =>
        this.selectedconfirmValue[index] === 'Yes' || this.selectedconfirmValue[index] === 'No');
    }

    displayQAndA(event) {
      if (event && !this.showIneligibility) {
        this.showRole = true;
        this.showConfirmedUserRole = false;
        this.showConfirmRole = false;
        this.showWorkplace = false;
        this.showEditIcons = false;
        this.hideButtons = true;
        const editIconSelected = {
          editIconSelected: true
        };
        this.roleValue = { 'value': this.selectedRole, 'text': this.selectedRole };
        this.editSelected.emit(editIconSelected);
        this.progressTrackerEvent.emit('roleDetails');
      }
      if (event && this.showWorkplace) {
        this.showRole = true;
        this.showConfirmedUserRole = false;
      }
    }

    roleConfirmYes(e, idx) {
      if (e.key === 'Enter' || e.type === 'click') {
        this.showIneligibility = false;
        this.selectedconfirmValue[idx] = 'Yes';

        if (this.selectedconfirmValue && this.selectedconfirmValue.length > 0) {
          const id = this.selectedconfirmValueExt.find(x => x.id === idx);
          if (id === undefined) {
            this.indexYesCount++;
            this.indexCount++;
          }
          if (this.indexYesCount <= 3) {
            this.selectedconfirmValueExt.push({
              id: idx,
              value: 'Yes'
            });
          }

        }
        this.checkIfAllQuestionsAnswered();
      }
    }

    roleConfirmNo(e, idx) {
      if (e.key === 'Enter' || e.type === 'click') {
        this.showIneligibility = false;
        this.selectedconfirmValue[idx] = 'No';
        if (this.selectedconfirmValue && this.selectedconfirmValue.length > 0) {
          const id = this.selectedconfirmValueExt.find(x => x.id === idx);
          if (id === undefined) {
            this.indexNoCount++;
            this.indexCount++;
          }
          if (this.indexNoCount <= 3) {
            this.selectedconfirmValueExt.push({
              id: idx,
              value: 'No'
            });
          }
        }
        this.checkIfAllQuestionsAnswered();
      }
    }

    confirmCheckboxCheck(event) {
      if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
        this.showCheckboxQA = true;
      }
    }

    confirmCheckbox(event) {
      if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
        this.closeBadCodePopup();
        this.showRole = false;

        let confirmvalue = true;

        if (this.selectedconfirmValue && this.selectedconfirmValue.length > 0) {
          this.selectedconfirmValue.forEach(element => {
            if (element === 'No') {
              confirmvalue = false;
              this.showConfirmRole = false;
              this.showIneligibility = true;
            }
          });
        }
        if (!confirmvalue) {
          this.showIneligibility = true;
          sessionStorage.setItem('showIneligibility', 'true');
          sessionStorage.setItem('selectedCategory', this.selectedCategory);
          sessionStorage.setItem('selectedRole', this.selectedRole);
          this.showCategory = false;
          this.showRole = false;
          this.showConfirmRole = false;
          this.showWorkplace = false;
          this.showConfirmedUserRole = false;
          this.hideButtons = false;
          this.displayNote = false;
          window.scrollTo(0, 0);
          this.router.navigate([CfetPageNamesConstant.CUSTOMER_ELIGIBILITY_UTF]);
          return;
        }
        this.applyRapidSosOrgSelection();
        // RapidSOS orgs still need the user to confirm where their organization is
        // located, so send them to the state/zip workplace step instead of
        // skipping straight to the "We found your organization" completion page.
        if (this.isRapidSosFlow) {
          sessionStorage.setItem('verificationType', 'agency');
          this.verificationTypeChange.emit('agency');
          sessionStorage.setItem('selectedCategory', this.selectedCategory);
          sessionStorage.setItem('selectedRole', this.selectedRole);
          // Recovery on the forced reload only restores selectedCategory/selectedRole,
          // so persist these too or onEligibilityCompletion() crashes on undefined.
          sessionStorage.setItem('selectedJobFunctionDetails', JSON.stringify(this.selectedJobFunctionDetails || []));
          sessionStorage.setItem('roleList', JSON.stringify(this.roleList || []));
          sessionStorage.setItem('fromOrgAssignment', 'true');
          sessionStorage.setItem('forceWorkplaceSection', 'true');
          this.stateAndZip = { state: '', zipcode: '' };
          this.showCategory = false;
          this.showRole = false;
          this.showConfirmRole = false;
          this.showEditIcons = false;
          this.showIneligibility = false;
          this.showEligibilityCompletion = false;
          this.showWorkplaceSection = true;
          this.showWorkplace = true;
          this.showConfirmedUserRole = true;
          this.hideButtons = false;
          this.router.navigate([CfetPageNamesConstant.CUSTOMER_ELIGIBILITY_UTF]);
          this.isRoleSelected.emit(true);
          this.progressTrackerEvent.emit('orgDetails');
          return;
        }
        if (this.isAffiliationFlow && this.orgId) {
          sessionStorage.setItem('verificationType', 'agency');
          this.verificationTypeChange.emit('agency');
          sessionStorage.setItem('selectedCategory', this.selectedCategory);
          sessionStorage.setItem('selectedRole', this.selectedRole);
          this.getOrgProfile();
          return;
        }
        sessionStorage.setItem('verificationType', 'self');
        this.verificationTypeChange.emit('self');
        sessionStorage.setItem('fromOrgAssignment', 'true');
        sessionStorage.setItem('forceWorkplaceSection', 'true');
        sessionStorage.setItem('selectedJobFunctionDetails', JSON.stringify(this.selectedJobFunctionDetails || []));
        sessionStorage.setItem('roleList', JSON.stringify(this.roleList || []));
        this.showCategory = false;
        this.showRole = false;
        this.showConfirmRole = false;
        this.showEditIcons = false;
        this.showIneligibility = false;
        this.showWorkplaceSection = true
        this.showEligibilityCompletion = true;
        this.showWorkplace = true;
        this.showConfirmedUserRole = true;
        this.hideButtons = false;
        sessionStorage.setItem('selectedCategory', this.selectedCategory);
        sessionStorage.setItem('selectedRole', this.selectedRole);
        if (!this.isAffiliationFlow) {
          sessionStorage.setItem('continueWithoutCode', this.continueWithoutAffiliation ? 'true' : 'false');
          const orgDetailRaw = sessionStorage.getItem('orgDetailInfo');
          if (orgDetailRaw && orgDetailRaw !== 'undefined') {
            try {
              const org = JSON.parse(orgDetailRaw);
              const agencyName =
                org?.org_name ||
                org?.selectedName ||
                org?.orgName ||
                '';
              if (agencyName) {
                sessionStorage.setItem('agencyNameSource', 'userSearchResult');
                sessionStorage.setItem('agencyName', agencyName);
              } else {
                sessionStorage.removeItem('agencyNameSource');
                sessionStorage.removeItem('agencyName');
              }
            } catch {
              console.warn('Invalid orgDetailInfo');
              sessionStorage.removeItem('agencyNameSource');
              sessionStorage.removeItem('agencyName');
            }
          } else {
            sessionStorage.removeItem('agencyNameSource');
            sessionStorage.removeItem('agencyName');
          }
        }
        this.openBadCodeModal = 'close';
        this.showConfirmedUserRole = true;
        this.showConfirmRole = true;
        this.showEditIcons = false;
        this.setTrueToShowWorkplace(true);
        const eligibilityInfo: any = {
          selectedRole: this.selectedRole,
          entity: this.selectedCategory,
          eligibilityStatus: {
            completionStatus: true
          },
          action: 'eligibility',
          selectedJobFunctionDetails: this.selectedJobFunctionDetails,
          rolelist: this.roleList
        };
        this.selectedJobFunctionDetails.forEach(element => {
          if (element.jobCategory === this.selectedRole) {
            eligibilityInfo.type = element.type;
            eligibilityInfo.userType = element.userType;
            eligibilityInfo.subType = element.subType;
            eligibilityInfo.status = element.status;
            eligibilityInfo.documents = element.documents;
            eligibilityInfo.questions = element.questions;
            eligibilityInfo.note = element.note;
          }
        });
        sessionStorage.setItem('eligibilityInfo', JSON.stringify(eligibilityInfo));
        this.router.navigate([CfetPageNamesConstant.CUSTOMER_ELIGIBILITY_UTF]);
        console.log("WITHOUT CODE FLOW → eligibilityInfo set:", eligibilityInfo);
        this.isRoleSelected.emit(true);
        this.progressTrackerEvent.emit('orgDetails');
        return;
      }
    }
    setTrueToShowWorkplace(confirmvalue) {
      if (confirmvalue === true) {
        if (this.showConfirmCheckbox === true) {
          this.hideButtons = false;
          this.showWorkplace = true;
          if (this.stateAndZip === '') {
            this.showWorkplaceSection = true;
          }
        }
      } else {
        this.showIneligibility = true;
      }
    }

    emitEligibilityCompletionStatus() {
      const rawOrg = sessionStorage.getItem('orgDetailInfo');
      if (rawOrg && rawOrg !== 'undefined') {
        let orgData;
        try {
          orgData = JSON.parse(rawOrg);
        } catch (e) {
          console.warn('Invalid orgDetailInfo JSON:', rawOrg);
          return;
        }
        this.getorgProfileInfo = orgData;
        this.checkstateAndZip(this.getorgProfileInfo);
        const eligibilitystatus = {
          completionStatus: this.showtickicon
        };
        this.hideButtons = false;
        this.hideWorkplaceSection(true);
        this.eligibilitycompletionstatus.emit(eligibilitystatus);
      }
    }

    showLoadingSpinner(event) {
      this.showSpinner = event;
      this.cd.detectChanges();
    }

    hideWorkplaceSection(event) {
      if (event !== undefined) {
        this.hideWorkplace = event;
      }
      if (this.hideWorkplace === true) {
        this.hideButtons = false;
        this.showWorkplace = true;
        this.showWorkplaceSection = false;
        this.showtickicon = true;
      }
    }

    checkstateAndZip(event) {
      if (event !== undefined && event.state && event.zipcode && event.state !== '') {
        this.manuallyEnteredValues = {};
        this.stateAndZip = event;
        sessionStorage.setItem('orgDetailInfo', JSON.stringify(event));
      }
    }

    saveManualValues(event) {
      if (event !== undefined) {
        this.manuallyEnteredValues = event;
      }
    }

    onClickCategory(event) {
      if (event.target.ariaExpanded === 'true') {
        this.checkCategory = 'dropdown-opened';
      } else {
        this.checkCategory = '';
      }
    }

    onClickRole(event) {
      if (event.target.ariaExpanded === 'true') {
        this.checkRole = 'dropdown-opened';
      } else {
        this.checkRole = '';
      }
    }

    getEntityList() {
      this.isEntityListLoading = true;
      this.setLoading(true);
        this.cfetService.cfetLiveGet('', CFETILMEndpointsConstant.ENTITY_LIST_V3).subscribe((data: any) => {
          this.addFirstResponderCategoriesList(data);
          this.isEntityListLoading = false;
          this.setLoading(false);
          console.log("Raw APi response:", data);
        }, (error) => {
          console.log('Error fetching entity list:', error);
          this.isEntityListLoading = false;
          this.setLoading(false);
        });
    }

    addFirstResponderCategoriesList(data: any) {
      this.categoryList = [];
      if (data && data.firstResponderCategories) {
        console.log('addFirstResponderCategoriesList:this.isPSEAffliationcode: ' + this.isPSEAffliationcode);
        console.log('addFirstResponderCategoriesList:this.isEVSP: ' + this.isEVSP);
        this.fullCategoryData = data.firstResponderCategories;
        this.responderCategoriesresponse = {};
        this.fullCategoryData.forEach((cat: any) => {
          this.responderCategoriesresponse[cat.categoryName] =
            (cat.firstResponderJobs || []).map((job: any) => ({
              responder_sub_category: job.jobName,
              note: job.note,
              questions: job.questions,
              type: Array.isArray(job.type) ? job.type[0] : job.type,
              user_type: job.user_type,
              subtype: job.subtype || job.sub_type,
              status: Array.isArray(job.status) ? job.status[0] : job.status,
              documents: job.documents,
              subpaid_program: job.subpaid_program,
              user_category: job.user_category || job.userCategory || job.usercategory,
              exclude_orgs: job.exclude_orgs
            }));
        });
        for (const entity in this.responderCategoriesresponse) {
          if (this.isRapidSosFlow && this.isExcludedRapidSosCategory(entity)) {
            continue;
          }
          if (Array.isArray(this.responderCategoriesresponse[entity])) {
            const matchedResponderJob =
              (this.affiliationResponderJobs || []).find(
                (job: any) =>
                  job.categoryName
                    ?.trim()
                    .toLowerCase() ===
                  entity
                    ?.trim()
                    .toLowerCase()
              );
            const normalizedFanTypes =
              (this.affiliationFanTypes || []).map(
                (type: string) =>
                  type
                    .replace(/subscriber paid/ig, '')
                    .trim()
                    .toLowerCase()
              );
            const responderJobsEmpty = (this.affiliationResponderJobs || []).length === 0;
            let hasMatchingFanType = false;

            if (responderJobsEmpty) {
              hasMatchingFanType = this.responderCategoriesresponse[entity].some((item: any) => {
                if (this.shouldHideJobForEVSP(item)) {
                  return false;
                }
                if (this.isSpaAffiliationOrg() && this.isOnlyAgencyVerified(item)) {
                  return false;
                }
                const normalizedUserType =
                  (item.user_type || '')
                    .replace(/subscriber paid/ig, '')
                    .trim()
                    .toLowerCase();
                return normalizedFanTypes.includes(normalizedUserType);
              });
            } else {
              if (matchedResponderJob) {
                hasMatchingFanType = this.responderCategoriesresponse[entity].some((item: any) => {
                  if (this.shouldHideJobForEVSP(item)) {
                    return false;
                  }
                  if (this.isSpaAffiliationOrg() && this.isOnlyAgencyVerified(item)) {
                    return false;
                  }
                  const normalizedUserType =
                    (item.user_type || '')
                      .replace(/subscriber paid/ig, '')
                      .trim()
                      .toLowerCase();
                  const normalizedJobName =
                    (item.responder_sub_category || '')
                      .trim()
                      .toLowerCase();

                  const responderJobNames =
                    this.getMatchedResponderJobNamesByFanType(
                      matchedResponderJob,
                      normalizedFanTypes
                    );

                  return normalizedFanTypes.includes(normalizedUserType)
                    && responderJobNames.includes(normalizedJobName);
                });
              } else {
                hasMatchingFanType = false;
              }
            }

            if (this.isAffiliationFlow) {
              console.log('[EligibilityUTF] addFirstResponderCategoriesList check', {
                hasMatchedResponderJob: !!matchedResponderJob,
                hasMatchingFanType,
                responderJobsEmpty: (this.affiliationResponderJobs || []).length === 0
              });
            }
            if (
              (this.isAffiliationFlow && hasMatchingFanType)
              || (!this.isAffiliationFlow)
            ) {
              if (this.continueWithoutAffiliation && !this.isAffiliationFlow) {
                const jobs = this.responderCategoriesresponse[entity];
                if (Array.isArray(jobs) && jobs.length > 0 && jobs.every((item: any) => this.isOnlyAgencyVerified(item))) {
                  continue;
                }
              }
              this.categoryList.push({
                value: entity,
                text: entity
              });
            }
          }
        }
        this.categoryList.sort((a, b) =>
          a.value.localeCompare(b.value)
        );
        this.logCategoryFlowState('ADD_FIRST_RESPONDER_CATEGORIES_LIST_DONE', {
          isAffiliationFlow: this.isAffiliationFlow,
          firstThreeCategories: (this.categoryList || []).slice(0, 3)
        });
    }
  }
    getCountOfNonAVSP(category: any[]) {
      return category.filter(item =>
        !item.subpaid_program || (Array.isArray(item.subpaid_program) && !(item.subpaid_program.length === 1 && item.subpaid_program[0] === "Agency Verified"))
      ).length;
    }

    getCountOfNonSpaOrg(category: any[]) {
      return category.filter(item =>
        !item.exclude_orgs || (Array.isArray(item.exclude_orgs) && item.exclude_orgs.length > 0 && !item.exclude_orgs[0].includes('isSpaOrg:True'))
      ).length;
    }

    onEligibilityCompletion(event) {
      let eligibilityStatus;
      if (event.manualEntry) {
        eligibilityStatus = event.eligibilityStatus;
      } else {
        eligibilityStatus = event;
      }
      this.showEditIcons = true;
      this.progressTrackerEvent.emit('EligibilityCompletion');
      const eligibilityInfo = {
        selectedRole: this.selectedRole,
        entity: this.selectedCategory,
        eligibilityStatus: eligibilityStatus,
        action: 'eligibility'
      };
      this.showEligibilityCompletion = eligibilityStatus;
      eligibilityInfo['selectedJobFunctionDetails'] = this.selectedJobFunctionDetails;
      this.selectedJobFunctionDetails.forEach(element => {
        if (element.jobCategory === this.selectedRole) {
          eligibilityInfo['type'] = element.type;
          eligibilityInfo['userType'] = element.userType;
          eligibilityInfo['subType'] = element.subType;
          eligibilityInfo['status'] = element.status;
          eligibilityInfo['documents'] = element.documents;
          eligibilityInfo['questions'] = element.questions;
          eligibilityInfo['note'] = element.note;
        }
      });
      eligibilityInfo['rolelist'] = this.roleList;
      console.log('[EligibilityUTF] WRITING eligibilityInfo after workplace step', eligibilityInfo);
      sessionStorage.setItem('eligibilityInfo', JSON.stringify(eligibilityInfo));
      this.eligibilitycompletionstatus.emit(eligibilityInfo);
      this.showWorkplaceSection = false;
      this.showWorkplace = false;
      this.router.navigate([CfetPageNamesConstant.CUSTOMER_ELIGIBILITY_UTF, 'completion']);
    }

    onEditSelection(event) {
      if (event && event.editJobDetails) {
        this.showRole = true;
        this.showConfirmedUserRole = false;
        this.showConfirmCheckbox = true;
        this.showConfirmRole = true;
        this.showWorkplace = false;
        this.hideButtons = true;
        this.showEditIcons = false;
        this.roleValue = { 'value': this.selectedRole, 'text': this.selectedRole };
      } else {
        this.showEditIcons = false;
      }
    }

    correctEligibleChoice(event) {
      if (event && this.showIneligibility) {
        this.showIneligibility = false;
        this.showConfirmRole = true;
        this.showWorkplace = false;
        this.showEditIcons = false;
        this.hideButtons = true;
        this.showCheckboxQA = true;
        this.showConfirmCheckbox = true;
        this.showRole = true;
        this.displayNote = true;
        this.showConfirmedUserRole = false;
      }
    }

    displayCancelModal(event) {
      if (event) {
        this.showCancelModal.emit(true);
      }
    }

    cancelApplication(event) {
      if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
        this.closeBadCodePopup();
        this.showCancelModal.emit(true);
      }
    }

    cancel(event) {
      if (event.type === 'click' || event.key === 'Enter' || event.keyCode === 13) {
        const rawUrl = sessionStorage.getItem('returnUrl');
        if (rawUrl && rawUrl !== 'undefined') {
          let parsedUrl;
          try {
            parsedUrl = JSON.parse(rawUrl);
          } catch (e) {
            console.warn('Invalid returnUrl JSON:', rawUrl);
            parsedUrl = null;
          }
          if (parsedUrl) {
            this.url = this.sanitizeReturnUrl(parsedUrl);
            if (this.url && this.url.indexOf('?') === -1) {
              this.redirectUrlFn(encodeURIComponent(this.url + '?fnStatus=ineligible'));
            } else if (this.url) {
              this.redirectUrlFn(encodeURIComponent(this.url + '&fnStatus=ineligible'));
            }
          }
        } else {
          // Redirect to plpPage
          const url = environment.plp_page;
          this.redirectUrlFn(encodeURIComponent(url + '&fnStatus=ineligible'));
        }
        sessionStorage.clear();
        this.isRoleSelected.emit(false);
        ('roleDetails');
      }
    }

    redirectUrlFn(url) {
      if (this.isEncoded(url)) {
        const decodedUrl = decodeURIComponent(url);
        const safeUrl = this.sanitizeReturnUrl(decodedUrl);
        if (safeUrl) {
          window.location.href = safeUrl;
        } else {
          window.location.href = environment.plp_page;
        }
      }
    }

    isEncoded(url) {
      if (url != '') {
        return url !== decodeURIComponent(url);
      }
    }

  private sanitizeReturnUrl(rawUrl: any): string {
    if (!rawUrl || typeof rawUrl !== 'string') {
      return '';
    }
    try {
      const parsed = new URL(rawUrl, window.location.origin);
      if (!this.isAllowedRedirectTarget(parsed)) {
        return '';
      }
      if (parsed.origin === window.location.origin) {
        return parsed.pathname + parsed.search + parsed.hash;
      }
      return parsed.toString();
    } catch (e) {
      return '';
    }
  }

  private isAllowedRedirectTarget(url: URL): boolean {
    if (!url || !/^https?:$/i.test(url.protocol)) {
      return false;
    }
    const allowedOrigins = [window.location.origin, environment.signup_domain];
    return allowedOrigins.indexOf(url.origin) !== -1;
  }

}
